// Role strings have been observed with inconsistent casing from the backend
// ("Admin" vs "admin") — always compare case-insensitively.
export const isAdminRole = (role?: string | null): boolean =>
  (role || "").toLowerCase() === "admin";
